import { HelpfullLink } from '@shared';

const REFUND_LINK: HelpfullLink = {
  label: 'Returns and refunds',
  url: 'info/return-and-refund',
};

const TERMS_AND_CONDITIONS_LINK: HelpfullLink = {
  label: 'Store and product policy',
  url: 'info/terms-and-conditions',
};

const SHIPPING_POLICY_LINK: HelpfullLink = {
  label: 'Shipping and delivery',
  url: 'info/shippingpolicy',
};

const buildFaqLink = (shopName: string): HelpfullLink => ({
  label: `${shopName} FAQs`,
  url: 'info/faq',
});

export const shippingAndDeliveryHelpfullLinksFabric = (shopName: string): HelpfullLink[] => [
  REFUND_LINK,
  TERMS_AND_CONDITIONS_LINK,
  buildFaqLink(shopName),
];

export const FAQHelpfullLinksFabric = (): HelpfullLink[] => [
  REFUND_LINK,
  SHIPPING_POLICY_LINK,
  TERMS_AND_CONDITIONS_LINK,
];

export const ReturnsAndRefundsHelpfullLinksFabric = (shopName: string): HelpfullLink[] => [
  SHIPPING_POLICY_LINK,
  TERMS_AND_CONDITIONS_LINK,
  buildFaqLink(shopName),
];

export const termsAndConditionsHelpfullLinksFabric = (shopName: string): HelpfullLink[] => [
  REFUND_LINK,
  buildFaqLink(shopName),
  SHIPPING_POLICY_LINK,
];

export const privacyPolicyHelpfullLinksFabric = (shopName: string): HelpfullLink[] => [
  REFUND_LINK,
  TERMS_AND_CONDITIONS_LINK,
  buildFaqLink(shopName),
];
